import * as React from 'react';
import './index.scss';
interface Props {
  url: string;
  height?: number,
  type?: number;
}
const { useState } = React;
const Rule: React.FC<Props> = (props) => {
  const [height, setHeight] = useState<number | string>('auto');
  const calcHeight = (): void => {
    // document.domain = 'huya.com';
    const iframe: any = document.getElementById('rules');
    if (iframe) {
      const iframeWin: any =
        iframe.contentWindow || iframe.contentDocument.parentWindow;
      try {
        if (iframeWin.document.body) {
          const heights: number =
            iframeWin.document.documentElement.scrollHeight ||
            iframeWin.document.body.scrollHeight;
          setHeight(heights);
        }
      } catch (error) {
        setHeight(props.height || 4000);
      }
    }
  };
  return (
    <div className="rule-comp" style={{ width: (props.type || 2) === 2 ? ('1244px') : '10rem'}}>
      <iframe
        id="rules"
        height={4300}
        className="rules"
        src={props.url}
        // onLoad={calcHeight}
      ></iframe>
    </div>
  );
}

export default Rule;